<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row no-gutters">
        <div class="col-xl-9">
          <div class="auth-full-bg pt-lg-5 p-4">
            <div class="w-100">
              <div class="bg-overlay"></div>
              <div class="d-flex h-100 flex-column">
                <div class="p-4 mt-auto">
                  <div class="row justify-content-center">
                    <div class="col-lg-7">
                      <div class="text-center">
                        <h4 class="mb-3">Divnotex</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->

        <div class="col-xl-3">
          <div class="p-md-5 p-4">
            <div class="w-100">
              <div class="d-flex flex-column h-100">
                <div class="mb-4 mb-md-5">
                  <router-link to="/" class="d-block auth-logo">
                    <img
                      src="@/assets/images/divnotex_logo_large_black.png"
                      alt=""
                      height="50"
                      class="auth-logo-dark"
                    />
                    <img src="@/assets/images/divnotex_logo_small.png" alt="" height="18" class="auth-logo-light" />
                  </router-link>
                </div>
                <div class="my-auto" style="padding-top: 100px">
                  <div>
                    <h3 class="text-primary">Авторизация</h3>
                  </div>

                  <div class="mt-4">
                    <form>
                      <b-form-group label="Email">
                        <b-form-input v-model="userEmail" @focus="$v.userEmail.$touch" />
                        <span v-if="!$v.userEmail.required && $v.userEmail.$dirty" class="text-danger">
                          Поле обязательно
                        </span>
                        <span v-if="!$v.userEmail.email && $v.userEmail.$dirty" class="text-danger">
                          Введите корректный email
                        </span>
                      </b-form-group>
                      <b-form-group label="Пароль" class="password">
                        <b-form-input
                          v-model="userPassword"
                          :type="showPassword ? 'text' : 'password'"
                          @focus="$v.userPassword.$touch"
                        />
                        <div class="password__button" @click="showPassword = !showPassword">
                          <i v-if="!showPassword" class="bx bx-hide password__icon"></i>
                          <i v-if="showPassword" class="bx bx-show password__icon"></i>
                        </div>

                        <span v-if="!$v.userPassword.required && $v.userPassword.$dirty" class="text-danger">
                          Поле обязательно
                        </span>
                      </b-form-group>

                      <b-button block variant="primary" class="mt-5 mb-5" @click="loginUser(userEmail)">
                        Войти
                      </b-button>

                      <div style="display: flex; justify-content: center">
                        <b-spinner v-if="isFetching" variant="primary" />
                      </div>

                      <app-inline-alert v-model="loginError" variant="danger">{{ loginErrorMessage }}</app-inline-alert>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
import { instanceLogin } from '@/api/instance';
import AppInlineAlert from '@/components/notifications/AppInlineAlert';

export default {
  name: 'Login',
  components: { AppInlineAlert },
  data() {
    return {
      userEmail: '',
      userPassword: '',
      showPassword: false,
      loginError: false,
      isFetching: false,
      loginErrorMessage: ''
    };
  },
  validations: {
    userEmail: { required, email },
    userPassword: { required }
  },
  methods: {
    async loginUser() {
      this.$v.$touch();
      if (this.$v.$dirty && this.$v.$anyError) {
        window.scrollTo(0, 0);
        return;
      }

      this.loginError = false;
      this.isFetching = true;

      let response;
      try {
        response = await instanceLogin.post('login', {
          email: this.userEmail,
          password: this.userPassword
        });
      } catch (e) {
        response = e.response;
      }

      if (response && response.data && Array.isArray(response.data.errors)) {
        if (response.data.errors.length === 0) {
          localStorage.setItem('userEmail', this.userEmail);
          await this.$store.dispatch('auth/loginUser', response.data.message.token);
        } else if (response.data.errors[0] === 'must change password') {
          localStorage.setItem('userEmail', this.userEmail);
          localStorage.setItem('tempToken', response.data.message.token);
          await this.$router.push({ name: 'ForceChangePassword' });
        } else {
          this.loginError = true;
          const errorMessage = response.data.errors[0];
          if (errorMessage === 'incorrect username or password') {
            this.loginErrorMessage = 'Не удалось авторизоваться, проверьте корректность введенных данных';
          }
          if (errorMessage === 'password expired') {
            this.loginErrorMessage = 'У пароля истек срок давности. Обратитесь к администратору.';
          }
          if (errorMessage === 'account inactive') {
            this.loginErrorMessage = 'Пользователь заблокирован за неактивность. Обратитесь к администратору.';
          }
          if (errorMessage === 'too many retries') {
            const retryAfterMinutes = Math.ceil(response.data.retryAfter / 60);
            this.loginErrorMessage = `Превышено количество попыток входа. Попробуйте еще раз через ${retryAfterMinutes} минут.`;
          }
        }
      } else {
        this.loginError = true;
      }

      this.isFetching = false;
    }
  }
};
</script>

<style lang="scss">
.password {
  position: relative;
  &__button {
    position: absolute;
    top: 0;
    right: 0;
  }
  &__icon {
    margin-top: 4px;
    margin-right: 5px;
    font-size: 30px;
  }
}
</style>
